import { campaignRouteNames } from '@/app/campaigns/constants';
/** @import { RouteRecordRaw } from 'vue-router' */

const App = () => import('@/app/campaigns/App.vue');
const Campaigns = () => import('@/app/campaigns/pages/Campaigns.vue');

const CampaignDetail = () => import('@/app/campaigns/pages/CampaignDetail.vue');
const CampaignEdit = () => import('@/app/campaigns/pages/CampaignEdit.vue');

const PAGE_LEVEL_TOP = `Campaigns`;

/** @type {RouteRecordRaw} */
export default {
  path: 'campaigns',
  component: App,
  redirect: { name: campaignRouteNames.CAMPAIGNS },
  meta: {
    requiresAuth: true,
    hideSecondaryNav: false,
  },
  children: [
    {
      name: campaignRouteNames.CAMPAIGNS,
      path: '',
      component: Campaigns,
      props: {
        to: { name: campaignRouteNames.CAMPAIGNS },
      },
      meta: {
        analytics: PAGE_LEVEL_TOP,
      },
      children: [
        {
          name: campaignRouteNames.CAMPAIGNS_CREATE,
          path: 'new',
          meta: {
            modal: {
              component: 'CampaignCreate',
              props: {
                mode: 'create',
              },
            },
            analytics: `${PAGE_LEVEL_TOP} - New`,
          },
        },
      ],
    },
    {
      name: campaignRouteNames.CAMPAIGN_DETAIL,
      path: ':id',
      redirect: { name: campaignRouteNames.CAMPAIGN_DETAIL_OWNED_SUMMARY },
      component: CampaignDetail,
      props: {
        to: { name: campaignRouteNames.CAMPAIGN_DETAIL },
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Detail`,
      },
      children: [
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_EDIT,
          path: 'edit',
          component: CampaignEdit,
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Edit`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_DELETE,
          path: 'delete',
          analytics: `${PAGE_LEVEL_TOP} - Detail - Delete`,
        },
        {
          // Legacy route, only used for redirection
          name: campaignRouteNames.CAMPAIGN_DETAIL_OVERVIEW,
          path: 'overview',
          redirect: { name: campaignRouteNames.CAMPAIGN_DETAIL_OWNED_SUMMARY },
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Overview`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_OWNED_SUMMARY,
          path: 'owned-summary',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Owned Summary`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_SOCIAL_ADS_SUMMARY,
          path: 'social-ads-summary',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Social Ads Summary`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_CREATOR_SUMMARY,
          path: 'creator-summary',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Creator Summary`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_TIKTOK,
          path: 'tiktok',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - TikTok`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_INSTAGRAM,
          path: 'instagram',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Instagram`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_INSTAGRAM_STORIES,
          path: 'instagram-stories',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Instagram Stories`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_FACEBOOK,
          path: 'facebook',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Facebook`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_PINTEREST,
          path: 'pinterest',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Pinterest`,
          },
        },
        {
          path: 'twitter:pathMatch(.*)*',
          redirect: (to) => ({ ...to, path: to.path.replace('/twitter', '/x') }),
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_TWITTER,
          path: 'x',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Twitter`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_YOUTUBE,
          path: 'youtube',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - YouTube`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_UGC,
          path: 'ugc',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Instagram UGC`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_TIKTOK_UGC,
          path: 'tiktok-ugc',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - TikTok UGC`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_META_ADS,
          path: 'meta-ads',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Meta Ads`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_TIKTOK_ADS,
          path: 'tiktok-ads',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - TikTok Ads`,
          },
        },
        {
          // Legacy route, only used for redirection
          name: campaignRouteNames.CAMPAIGN_DETAIL_CREATOR_INSIGHTS,
          path: 'creator-insights',
          redirect: { name: campaignRouteNames.CAMPAIGN_DETAIL_CREATOR_SUMMARY },
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Creator Insights`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_CREATOR_DELIVERABLES,
          path: 'creator-deliverables',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Creator Deliverables`,
          },
        },
        {
          // Legacy route, only used for redirection
          name: campaignRouteNames.CAMPAIGN_DETAIL_ECOMM,
          path: 'ecomm',
          redirect: { name: campaignRouteNames.CAMPAIGN_DETAIL_GOOGLE_ANALYTICS },
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Ecomm`,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_GOOGLE_ANALYTICS,
          path: 'google-analytics',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Google Analytics`,
          },
        },
      ],
    },
    {
      name: campaignRouteNames.CAMPAIGN_DETAIL_REPORT,
      path: ':id',
      redirect: { name: campaignRouteNames.CAMPAIGN_DETAIL_OWNED_SUMMARY_REPORT },
      component: CampaignDetail,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Detail - Report`,
        hideNav: true,
        hideVisionAi: true,
      },
      children: [
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_OWNED_SUMMARY_REPORT,
          path: 'owned-summary/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Owned Summary - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_SOCIAL_ADS_SUMMARY_REPORT,
          path: 'social-ads-summary/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Social Ads Summary - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_CREATOR_SUMMARY_REPORT,
          path: 'creator-summary/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Creator Summary - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_TIKTOK_REPORT,
          path: 'tiktok/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - TikTok - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_INSTAGRAM_REPORT,
          path: 'instagram/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Instagram - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_INSTAGRAM_STORIES_REPORT,
          path: 'instagram-stories/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Instagram Stories - Reports`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_FACEBOOK_REPORT,
          path: 'facebook/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Facebook - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_PINTEREST_REPORT,
          path: 'pinterest/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Pinterest - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_TWITTER_REPORT,
          path: 'twitter/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Twitter - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_YOUTUBE_REPORT,
          path: 'youtube/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - YouTube - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_UGC_REPORT,
          path: 'ugc/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Instagram UGC - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_TIKTOK_UGC_REPORT,
          path: 'tiktok-ugc/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - TikTok UGC - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_META_ADS_REPORT,
          path: 'meta-ads/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Meta Ads - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_TIKTOK_ADS_REPORT,
          path: 'tiktok-ads/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - TikTok Ads - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_CREATOR_DELIVERABLES_REPORT,
          path: 'creator-deliverables/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Creator Deliverables - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_GOOGLE_ANALYTICS_REPORT,
          path: 'google-analytics/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - Google Analytics - Report`,
            report: true,
          },
        },
        {
          name: campaignRouteNames.CAMPAIGN_DETAIL_ALL_TABS_REPORT,
          path: 'all/report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Detail - ALL Tabs - Report`,
            report: true,
          },
        },
      ],
    },
  ],
};
